import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Vehicles from '../components/Vehicles';
import { FiArrowRight } from 'react-icons/fi';

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    { "@type": "ListItem", "position": 1, "name": "Accueil", "item": "https://limousine-vip-paris.fr/" },
    { "@type": "ListItem", "position": 2, "name": "Véhicules", "item": "https://limousine-vip-paris.fr/vehicules" }
  ]
};

const vehicleSchemaList = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  "name": "Flotte de véhicules VIP Limousine Paris",
  "itemListElement": [
    {
      "@type": "Vehicle",
      "name": "Hummer H3 Stretch blanche",
      "vehicleConfiguration": "Limousine stretch",
      "numberOfPassengerCapacity": 8,
      "image": "https://limousine-vip-paris.fr/images/gallery/hummer-limousine-place-vendome-paris.webp",
      "brand": { "@type": "Brand", "name": "Hummer" }
    },
    {
      "@type": "Vehicle",
      "name": "Rolls Royce Phantom blanche",
      "vehicleConfiguration": "Berline ultra-luxe",
      "numberOfPassengerCapacity": 4,
      "image": "https://limousine-vip-paris.fr/images/gallery/rolls-royce-phantom-place-vendome-paris.webp",
      "brand": { "@type": "Brand", "name": "Rolls Royce" }
    },
    {
      "@type": "Vehicle",
      "name": "Chrysler 300 Stretch blanche",
      "vehicleConfiguration": "Limousine stretch",
      "numberOfPassengerCapacity": 8,
      "image": "https://limousine-vip-paris.fr/images/gallery/limousine-chrysler-place-vendome-paris.webp",
      "brand": { "@type": "Brand", "name": "Chrysler" }
    },
    {
      "@type": "Vehicle",
      "name": "Mercedes Classe S",
      "vehicleConfiguration": "Berline de luxe",
      "numberOfPassengerCapacity": 3,
      "image": "https://limousine-vip-paris.fr/images/gallery/limousine-blanche-place-vendome-nuit.webp",
      "brand": { "@type": "Brand", "name": "Mercedes-Benz" }
    },
    {
      "@type": "Vehicle",
      "name": "Citroën 2CV vintage",
      "vehicleConfiguration": "Voiture vintage",
      "numberOfPassengerCapacity": 3,
      "image": "https://limousine-vip-paris.fr/images/gallery/citroen-2cv-vintage-paris-mariage.webp",
      "brand": { "@type": "Brand", "name": "Citroën" }
    }
  ].map((v, i) => ({ "@type": "ListItem", "position": i + 1, "item": v }))
};

const vehiclePages = [
  { slug: '/location-rolls-royce-phantom-paris', label: 'Rolls Royce Phantom' },
  { slug: '/location-hummer-stretch-paris', label: 'Hummer H3 Stretch' },
  { slug: '/location-chrysler-300-stretch-paris', label: 'Chrysler 300 Stretch' },
  { slug: '/location-mercedes-classe-s-paris', label: 'Mercedes Classe S' },
  { slug: '/location-citroen-2cv-mariage', label: 'Citroën 2CV Vintage' }
];

const VehiclesPage = () => {
  return (
    <>
      <Helmet>
        <title>Flotte de Limousines & Voitures de Luxe à Paris | VIP Limousine</title>
        <meta name="description" content="Découvrez notre flotte premium : Rolls Royce Phantom, Hummer H3 stretch, Chrysler 300 stretch, Mercedes Classe S, Citroën 2CV vintage. Location avec chauffeur à Paris 24/7." />
        <link rel="canonical" href="https://limousine-vip-paris.fr/vehicules" />
        <meta property="og:title" content="Notre flotte de limousines à Paris - VIP Limousine" />
        <meta property="og:description" content="Rolls Royce, Hummer stretch, Chrysler stretch, Mercedes Classe S, 2CV vintage. Tous nos véhicules de luxe avec chauffeur." />
        <meta property="og:url" content="https://limousine-vip-paris.fr/vehicules" />

        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(vehicleSchemaList)}</script>
      </Helmet>

      <div style={{ paddingTop: '100px' }}>
        <Vehicles />

        <section className="section-padding" style={{ background: 'rgba(0,0,0,0.4)' }}>
          <div className="container">
            <div className="section-header text-center">
              <span className="section-badge">Pages dédiées</span>
              <h2 className="section-title">
                Choisissez votre véhicule en détail
                <span className="title-accent">tarifs, photos et options</span>
              </h2>
              <p className="section-description">
                Chaque modèle dispose de sa page dédiée avec photos, capacité, équipements,
                tarifs forfaitaires et FAQ.
              </p>
            </div>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
              gap: '0.75rem'
            }}>
              {vehiclePages.map((p) => (
                <Link
                  key={p.slug}
                  to={p.slug}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '0.9rem 1.1rem',
                    background: 'rgba(255,255,255,0.05)',
                    border: '1px solid rgba(212,175,55,0.2)',
                    borderRadius: '0.75rem',
                    color: 'var(--text-primary)',
                    textDecoration: 'none',
                    transition: 'all 0.2s'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = 'var(--primary-gold)';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = 'rgba(212,175,55,0.2)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  <span>Location {p.label} Paris</span>
                  <FiArrowRight color="var(--primary-gold)" />
                </Link>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default VehiclesPage;
